module.exports = __webpack_public_path__ + "static/img/summer_banner.97305420.jpg";